export default {"src":"https://images-cdn-staging.curipod.com/d-d2548d2f/_next/static/media/rocket.9360f2a3.svg","height":199,"width":200};